import { render, staticRenderFns } from "./coupon-form.vue?vue&type=template&id=21016954&"
import script from "./coupon-form.vue?vue&type=script&lang=js&"
export * from "./coupon-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports